import React, { useEffect, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { MenuItem } from '@tassomutuo-backoffice/types';
import { CtaButton, ModalContainer } from '@tassomutuo-backoffice/ui';

interface IProps {
  open: boolean;
  handleClose: () => void;
  changeMenuItemsOrder: (orderedMenuItems: MenuItem[]) => Promise<MenuItem[]>;
  menuItems: MenuItem[];
}

const MenuVoiceOrderModal = ({
  open,
  handleClose,
  changeMenuItemsOrder,
  menuItems,
}: IProps) => {
  const [menuItemToShow, setMenuItemToShow] = useState<MenuItem[]>(menuItems);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && menuItems) {
      setMenuItemToShow(menuItems);
    }
  }, [open, menuItems]);

  const confirmHandler = async () => {
    try {
      setLoading(true);
      await changeMenuItemsOrder(menuItemToShow);
      handleClose();
    } finally {
      setLoading(false);
    }
  };

  const moveItem = (from: number, to: number) => {
    // Do nothing if the start and end indices are the same,
    // or if the indices are out of bounds of the menuItems array
    if (
      from === to ||
      from < 0 ||
      to < 0 ||
      from >= menuItems.length ||
      to >= menuItems.length
    ) {
      return;
    }

    // Copy the menuItems array to avoid mutating the state directly
    const updatedMenuItems = [...menuItemToShow];

    // Remove the item from its original position
    const [removedItem] = updatedMenuItems.splice(from, 1);

    // Insert the item into the new position
    updatedMenuItems.splice(to, 0, removedItem);

    // Update the state with the new array of menuItems
    setMenuItemToShow(updatedMenuItems);
  };

  return (
    <ModalContainer
      open={open}
      handleClose={!loading ? handleClose : () => {}}
      mtHeader={0}
      title="Ordina voci menu"
    >
      <Box width="100%">
        {menuItemToShow.map((m, index) => (
          <Box
            key={m.id}
            sx={{
              p: 2,
              my: 2,
              bgcolor: (th) => alpha(th.palette.primary.dark, 0.2),
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography fontWeight="bold">{m.name}</Typography>
            <Box>
              <IconButton onClick={() => moveItem(index, index + 1)}>
                <ArrowDownwardIcon />
              </IconButton>
              <IconButton onClick={() => moveItem(index, index - 1)}>
                <ArrowUpwardIcon />
              </IconButton>
            </Box>
          </Box>
        ))}
        <Box display="flex" justifyContent="center" mt={4}>
          <CtaButton
            variant="contained"
            loading={loading}
            onClick={confirmHandler}
          >
            SALVA
          </CtaButton>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export default MenuVoiceOrderModal;
